import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { FinanceProvider } from './context/FinanceContext';
import AppLayout from './components/AppLayout';
import Home from './pages/Home';
import NewMonthWizard from './pages/NewMonthWizard';
import MonthDashboard from './pages/MonthDashboard';
import AllMonths from './pages/AllMonths';
import Login from './pages/Login';
import Register from './pages/Register';
import Reports from './pages/Reports';

import { ToastProvider } from './context/ToastContext';
import ToastContainer from './components/ToastContainer';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 text-center text-gray-500">Loading...</div>;
  if (!user) return <Navigate to="/login" />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="*" element={
        <ProtectedRoute>
          <FinanceProvider>
            <AppLayout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/new" element={<NewMonthWizard />} />
                <Route path="/month/:id" element={<MonthDashboard />} />
                <Route path="/months" element={<AllMonths />} />
                <Route path="/reports" element={<Reports />} />
              </Routes>
            </AppLayout>
          </FinanceProvider>
        </ProtectedRoute>
      } />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <BrowserRouter>
          <AppRoutes />
          <ToastContainer />
        </BrowserRouter>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
